<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      <span ref="topAnchor">
        {{ title }}
      </span>
    </template>

    <FormWrapper grid>
      <form @submit.prevent="submit">
        <div class="section">
          <FormInput name="name"
                     v-model="form.name"
                     :errors="errors"
                     class="sm:col-span-3"/>
        </div>

        <div class="section">
          <div class="sm:col-span-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Permissions
            </h3>
          </div>

          <div class="sm:col-span-4 flex justify-between">
            <div class="w-1/3"></div>
            <div>Read</div>
            <div>Write</div>
          </div>

          <div v-for="item in modules"
               :key="item"
               class="sm:col-span-4 flex justify-between">
            <div class="w-1/3">
              {{ item }}
            </div>
            <div>
              <FormCheckbox v-model="form.permissions[item].read"
                            :name="`permissions.${item}.read`"
                            :show-label="false"
                            :errors="errors"
                            class="-mr-4" />

            </div>
            <div>
              <FormCheckbox v-model="form.permissions[item].write"
                            :name="`permissions.${item}.write`"
                            :show-label="false"
                            :errors="errors"
                            class="-mr-4" />

            </div>
          </div>
        </div>

        <FormActions :cancelUrl="$route('roles.index')"
                     :show-submit="$can('roles.write')"
                     grid />
      </form>
    </FormWrapper>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import { Inertia } from '@inertiajs/inertia'
import { set } from 'lodash'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  props: {
    model: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: Object,
    modules: Array,
  },

  data() {
    const permissions = [...this.modules].reduce(
      (carry, name) => ({
        ...carry,
        [name]: { read: false, write: false },
      }),
      {}
    )

    const modelPermission = this.model?.permissions?.length
      ? [...this.model.permissions]
      : []

    modelPermission.forEach(item => {
      set(permissions, item.name, true)
    })

    return {
      title: `Roles :: ${this.model?.name}`,
      form: {
        name: this.model?.name,
        permissions,
      },
    }
  },

  methods: {
    submit() {
      Inertia.put(this.$route('roles.update', [this.model.id]), this.form, {
        onFinish: () => {
          this.$refs.topAnchor.scrollIntoView()
        }
      })
    },
  }
}
</script>
